import styled from 'styled-components'
import { SECONDARY_LIGHTER_COLOR, SECONDARY_NORMAL_COLOR } from '@CSSVars/colors'

export const _ImgPreviewBox = styled.div`
  position: relative;
  background-color: ${SECONDARY_LIGHTER_COLOR};
  width: 100%;
  display: flex;
  align-items: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

  span {
    color: white;
    width: 80%;
    text-align: center;
  }
  > div {
    height: 100%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`

export const _Preview = styled.div`
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  text-transform: uppercase;
  color: white;
  opacity: ${({ locked }) => (locked ? 1 : 0)};
  transition: all .5s ease-out;

  span {
    position: absolute;
    white-space: normal;
    line-height: 22px;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 1px);
    font-weight: normal;
    backface-visibility: hidden;
    text-transform: none;

    backface-visibility: hidden;
  }

  &:hover {
    cursor: pointer;
  }

   &:hover {
     cursor: pointer;
   }


`

export const _BgOverlay = styled.div`
  content: '';
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  background-color: ${SECONDARY_NORMAL_COLOR};
  opacity: 0.8;
  backface-visibility: hidden;
  transform: translate3d(0,0,1px);
`
